<script>
    import VideoPlayer from 'svelte-video-player';  
    export let source
    export let poster
    export let borderRadius = "0px"
  </script>
   
   <VideoPlayer color="#F78907" {source} {poster} {borderRadius}  />